export const GET_PAYMENT_CATEGORIES = "GET_PAYMENT_CATEGORIES";
export const GET_FILE_STATUS = "GET_FILE_STATUS";
export const GET_PAYMENT_STATUS = "GET_PAYMENT_STATUS";
export const GET_SAVE_PAYMENT = "GET_SAVE_PAYMENT";
export const GET_PAYMENT_BENEFICIARY = "GET_PAYMENT_BENEFICIARY";
export const GET_PAYMENT_FEES = "GET_PAYMENT_FEES";
export const GET_PARSE_RECORD = "GET_PARSE_RECORD";
export const FILE_PARSE_STATUS = "FILE_PARSE_STATUS";
export const FILE_PARSE_STATUS_DONE = "FILE_PARSE_STATUS_DONE";
export const GET_SAVED_PAYMENT = "GET_SAVED_PAYMENT";
export const GET_PAYMENT_DETAILS = "GET_PAYMENT_DETAILS";
export const GET_PUBLIC_KEY = "GET_PUBLIC_KEY";

export const UPDATE_PAYMENT_STATUS = "UPDATE_PAYMENT_STATUS";
